/** 상세 화면의 모드와 각 모드에 속한 보기를 정의한다. */
export type DatasetDetailTab = "metadata" | "analysis" | "episodeReview" | "review" | "annotation";
export const defaultDatasetDetailTab: DatasetDetailTab = "episodeReview";
export const datasetDetailTabs = [
  { value: "episodeReview", label: "리뷰" },
  { value: "analysis", label: "분석" },
  { value: "metadata", label: "메타 정보" },
  { value: "annotation", label: "Annotation" },
] as const;

/** 이전 Dataset 설정(review) 진입 값도 메타 정보 탭으로 연결한다. */
export function datasetDetailModeTab(
  tab: DatasetDetailTab,
): (typeof datasetDetailTabs)[number]["value"] {
  return tab === "review" ? "metadata" : tab;
}
export function adjacentDatasetDetailTab(
  tab: DatasetDetailTab,
  direction: 1 | -1,
): DatasetDetailTab | null {
  const index = datasetDetailTabs.findIndex((entry) => entry.value === datasetDetailModeTab(tab));
  return datasetDetailTabs[index + direction]?.value ?? null;
}
export function normalizeDatasetDetailTab(tab: string | null): DatasetDetailTab {
  switch (tab) {
    case "review":
      return "metadata";
    case "metadata":
    case "analysis":
    case "episodeReview":
    case "annotation":
      return tab;
    default:
      // 이전 뷰(episodes) 링크도 통합된 기본 리뷰 탭으로 연다.
      return defaultDatasetDetailTab;
  }
}
